module.exports = __webpack_public_path__ + "img/Img31_179481_CeEt-174-1E3-1823.21ecd4e2.jpg";